import { createVanIconComponent } from "./van"

const Revoke = createVanIconComponent("revoke")
export default Revoke
